(function ($, window, Drupal) {

    Drupal.behaviors.golfclub = {
        attach: function (context, settings) {
            $('.carousel-inner .carousel-item:first-child').addClass('active');
        }
    };

})(jQuery, window, Drupal);
